theme.Product = (function() {
  window.lastChangedOptionIndex = window.lastChangedOptionIndex == null ? null : window.lastChangedOptionIndex;

  function Product(container) {
    var $container = this.$container = $(container);


    selectCallback = function(variant, selector) {
        if (!variant) {
          // The currently selected combination of options doesn't exist as a
          // variant (e.g. leftover Size from a previous Style that this
          // Style doesn't offer). Keep whichever option the shopper just
          // changed and auto-correct the other option(s) to a value that
          // actually forms a real variant, preferring an in-stock one.
          var $form = jQuery('#' + selector.domIdPrefix).closest('form');
          var product = selector.product;
          var optionCount = product.options.length;
          var anchorIndex = window.lastChangedOptionIndex != null ? window.lastChangedOptionIndex : 0;
          var anchorValue = $form.find('input[name="option-' + anchorIndex + '"]:checked').val();

          var fallbackVariant = _.find(product.variants, function (v) {
            return v.options[anchorIndex] == anchorValue && v.available;
          }) || _.find(product.variants, function (v) {
            return v.options[anchorIndex] == anchorValue;
          });

          if (fallbackVariant) {
            for (var i = 0; i < optionCount; i++) {
              if (i === anchorIndex) continue;
              var $radio = $form.find('input[name="option-' + i + '"][value="' + fallbackVariant.options[i] + '"]');
              if ($radio.length && !$radio.prop('checked')) {
                $radio.prop('checked', true).trigger('change');
                return;
              }
            }
          }
        }

        $('body').trigger('selectCallbackAddon', [variant,selector]);
        var $product = $('#product-' + selector.product.id),
            $productForm = $('#AddToCartForm', $product);
        if (variant && variant.featured_image) {
        // Update variant image, if one is set
          var original_image = $("#product-main-image img"), new_image = variant.featured_image;
          Shopify.Image.switchImage(new_image, original_image[0], function (new_image_src, original_image, element) {
            $(element).attr('src', new_image_src);
            $('.thumbnail[data-image-id="' + variant.featured_image.id + '"]').trigger('click');
            // Update images if ALT is different from the default alt AKT Aug28
            //debugger;
            if(variant.featured_image.alt != null){
              if( variant.featured_image.alt.indexOf("swatch") > -1){
                let feat_img_alt = variant.featured_image.alt;
                $('.thumbnail').each(function(){
                  let $this_slide = $(this).parent();
                  if($(this).attr("alt") == feat_img_alt && $(this).attr("alt").indexOf("hide") == -1){
                    $this_slide.show();
                  }else{
                    $this_slide.hide();
                  }
                })
              }
            }
          });
        }
      
        // BEGIN SWATCHES
        if (variant) {
          var form = jQuery('#' + selector.domIdPrefix).closest('form');
          for (var i=0,length=variant.options.length; i<length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
            if (radioButton.length) {
              radioButton.get(0).checked = true;
            }
          }
        }
        // END SWATCHES
       
        if (variant) {
         
            $('.variant-sku').text(variant.sku);
            $(".stickybar .item-title .variant").text(variant.title);
        }
        else {
         
            $('.variant-sku').empty();
        }
        if (variant && variant.available == true) {
            if(variant.compare_at_price > variant.price){
                $('.was', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')))
            } else {
                $('.was', $product).text('')
            }
            $('.product-price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
            $('.add', $product).removeClass('disabled').removeAttr('disabled').val("Add to Cart");
        } else {
            var message = variant ? "Sold Out" : "Sold Out";
            $('.was', $product).text('')
            $('.product-price', $product).text(message);
            $('.add', $product).addClass('disabled').attr('disabled', 'disabled').val(message);
        }
        
    };

            
            
         /*In case product don't have variants*/        
    function addVariantSku(){
      let raw_data_product_json = $('#AddToCartForm ').attr("data-product");
      let data_product_json = JSON.parse(raw_data_product_json);
      let data_product_variant = data_product_json.variants;

      $.each(data_product_variant, function(i,item){       
      	$('.variant-sku').text(item.sku);
      })
    };          
     
    if ($('#AddToCartForm ').hasClass('with_variants')) {
      var prodId = $('.product-page').data("product-id"),
          productSingleObject = JSON.parse(document.getElementById('ProductJson-' + prodId).innerHTML);

      $('#AddToCartForm').each(function() {
        new Shopify.OptionSelectors('product-select-' + prodId, { product: productSingleObject, onVariantSelected:
        selectCallback, enableHistoryState: true });
      });

      $(document).on('shopify:section:unload', '.product-page', function(event){
        delete Shopify.OptionSelectors();
      });
  }else{
    addVariantSku();
  }


// Product images edit to work with new theme editor
    var initProdpage = function(Imagezoom) {
      if (_productSettings.zoom) {
        $('#product-main-image').zoom();
      }
      $('.clicker-thumb').click(function() {
        var newImage = $(this).attr('href');
        $( '#product-main-image img' ).attr({ src: newImage });
        return false;
      });
    };

    initProdpage($('#product-main-image'));

    $(document).on('shopify:section:unload', function(event) {
      var target = $(event.target);
      if (_productSettings.zoom) {
        target.find('#product-main-image').zoom('destroy');
      }
      $(document).off('#product-main-image');
    });

    $(document).on('shopify:section:load', function(event) {
      initProdpage($(event.target).find('#product-main-image'));
    });

/*
    var initThumbSlider = function(prodSlideshow) {
      // BXslider for product vertical thumb carousel
      $('.thumbnail-slider').bxSlider({
        mode: 'vertical',
        minSlides: 4,
        slideMargin: 10,
        infiniteLoop: false,
        pager: false,
        prevText: "",
        nextText: "",
        hideControlOnEnd: true
      });
    };


    initThumbSlider($('.thumbnail-slider'));
    $(document).on('shopify:section:unload', function(event) {
      var target = $(event.target);
      target.find('.thumbnail-slider').bxSlider("destroy");
      $(document).off('.thumbnail-slider');
    });

    $(document).on('shopify:section:load', function(event) {
      initThumbSlider($(event.target).find('.thumbnail-slider'));
    });*/

  if($(window).width() > 740){
    $('#product-main-image').zoom();
  };

  }
  Product.prototype = _.assignIn({}, Product.prototype, {});

  return Product;
})();
$(document).ready(function () {
  var productPage = window.location.pathname.indexOf('/products/') !== -1;

  $("#product-description .tabs .tab").each(function () {
    $(this).find(".tab-title").click(function () {
      if ($(this).find("h2").hasClass("collapsed") == false) {
        $(".tabs").find("h2").addClass("collapsed");
        $(".tabs").find(".tab-content").slideUp();
      } else {
        $(".tabs").find("h2").addClass("collapsed");
        $(this).find("h2").removeClass("collapsed");
        $(".tabs").find(".tab-content").slideUp();
        $(this).parent().find(".tab-content").slideDown();
      }
    });
  });

  // Product page - Thumbnail active
  $('.clicker-thumb').on('click', function (e) {
    $('#thumbnail-gallery .slide').removeClass('active');
    $(e.target).closest('.slide').addClass('active');
  });

  /* general read more function */
  $(".slide:first-of-type").addClass("active");
});

$(window).on('load', function () {
  var productPage = window.location.pathname.indexOf('/products/') !== -1;

  if (productPage) {
    setTimeout(function () {
      //Flickity.data('.module-trust-icons-items').select(2, true, true);
    }, 500);
    $("#product-description .swatch-element").on("click", function () {
      let selectedColor = $(this).attr("data-value");
              // gallery filter
              $(".desktop_sets_slider .thumbnail").each(function () {
                if($(this).attr("alt").indexOf(selectedColor) > -1 && $(this).attr("alt").indexOf("hide") == -1) {
                  //$(this).show();
                }else{
                  //$(this).hide();
                }
              })
    })
  }
});
/* SV 21.Sep.19 */
(function ($) {
  function preloadCarouselImages() {
    if (typeof _productImages == 'undefined' || typeof _ === 'undefined') return;

    _.each(_productImages, function (color) {
      color.imagesDom = [];
      _.each(color.images, function (img) {
        var image = new Image;
        image.src = img;
        color.imagesDom.push(image);
      });
    });
  }

  function getPrimaryMobileCarousel() {
    var $primaryCarousel = $('.mobile-images .mobile-carousel--primary').first();

    if ($primaryCarousel.length) {
      return $primaryCarousel;
    }

    return $('.mobile-images .mobile-carousel').not('.chart_imagesmobile').first();
  }

  function getMobileCarouselOptions() {
    return {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      dragThreshold: 25,
      imagesLoaded: true,
      pageDots: true
    };
  }

  function isFlickityInstance(instance) {
    return !!(
      instance &&
      typeof instance.destroy === 'function' &&
      typeof instance.select === 'function' &&
      typeof instance.resize === 'function'
    );
  }

  function clearStaleFlickityData($mobileCarousel) {
    var flktyData = $mobileCarousel.data('flickity');

    if (flktyData && !isFlickityInstance(flktyData)) {
      $mobileCarousel.removeData('flickity');
    }
  }

  function getMobileCarouselInstance($mobileCarousel) {
    if (!$mobileCarousel.length) return null;

    if (window.Flickity && typeof window.Flickity.data === 'function') {
      var flickityInstance = window.Flickity.data($mobileCarousel[0]);

      if (isFlickityInstance(flickityInstance)) {
        return flickityInstance;
      }
    }

    var flkty = $mobileCarousel.data('flickity');

    if (isFlickityInstance(flkty)) {
      return flkty;
    }

    return null;
  }

  function destroyMobileCarousel($mobileCarousel) {
    var flkty = getMobileCarouselInstance($mobileCarousel);

    if (flkty) {
      flkty.destroy();
    }
  }

  function selectMobileCarouselIndex($mobileCarousel, index) {
    var flkty = getMobileCarouselInstance($mobileCarousel);
    if (!flkty) return;

    flkty.select(index);
  }

  function initMobileCarousel($mobileCarousel) {
    if (!$mobileCarousel.length) return null;

    destroyMobileCarousel($mobileCarousel);
    clearStaleFlickityData($mobileCarousel);

    if (window.Flickity) {
      return new window.Flickity($mobileCarousel[0], getMobileCarouselOptions());
    }

    if (typeof $mobileCarousel.flickity === 'function') {
      $mobileCarousel.flickity(getMobileCarouselOptions());
      return getMobileCarouselInstance($mobileCarousel);
    }

    return null;
  }

  function renderFallbackMobileDots($mobileCarousel, selectedIndex) {
    if (!$mobileCarousel.length) return;

    var cellCount = $mobileCarousel.find('.carousel-cell').length;
    if (!cellCount) return;

    $mobileCarousel.find('.flickity-page-dots--fallback').remove();

    var $dots = $('<ol class="flickity-page-dots flickity-page-dots--fallback" aria-label="Product gallery pagination"></ol>');

    for (var i = 0; i < cellCount; i += 1) {
      var $dot = $('<li class="dot" aria-label="Page dot ' + (i + 1) + '"></li>');

      if (i === selectedIndex) {
        $dot.addClass('is-selected').attr('aria-current', 'step');
      }

      $dot.on('click', (function (index) {
        return function () {
          selectMobileCarouselIndex($mobileCarousel, index);
        };
      })(i));

      $dots.append($dot);
    }

    $mobileCarousel.append($dots);
  }

  function ensureMobileCarouselDots($mobileCarousel) {
    if (!$mobileCarousel.length) return;

    var flkty = getMobileCarouselInstance($mobileCarousel);

    if (!flkty) return;

    if (flkty.pageDots && flkty.pageDots.holder) {
      $mobileCarousel.find('.flickity-page-dots--fallback').remove();
      return;
    }

    renderFallbackMobileDots($mobileCarousel, flkty.selectedIndex || 0);

    $mobileCarousel.off('change.mobileDots select.mobileDots');
    $mobileCarousel.on('change.mobileDots select.mobileDots', function (event, index) {
      renderFallbackMobileDots($mobileCarousel, typeof index === 'number' ? index : 0);
    });
  }

  function mobileProductImagesCarousel() {
    var $mobileCarousel = getPrimaryMobileCarousel();
    var flkty = initMobileCarousel($mobileCarousel);

    if (flkty) {
      ensureMobileCarouselDots($mobileCarousel);
    }
  }

  function bootMobileProductCarousel(attempt) {
    attempt = attempt || 0;

    var $mobileCarousel = getPrimaryMobileCarousel();
    if (!$mobileCarousel.length) return;

    if (getMobileCarouselInstance($mobileCarousel)) {
      ensureMobileCarouselDots($mobileCarousel);
      return;
    }

    if (initMobileCarousel($mobileCarousel)) {
      ensureMobileCarouselDots($mobileCarousel);
      return;
    }

    if (attempt < 8) {
      window.setTimeout(function () {
        bootMobileProductCarousel(attempt + 1);
      }, 150);
    }
  }

  function updateSwatchAvailability(_product) {
    if (typeof _product == 'undefined') return;
    var optionCount = _product.options ? _product.options.length : 0;
    if (optionCount < 2) return;

    var $form = $('.product-form-' + _product.id);

    for (var targetIndex = 0; targetIndex < optionCount; targetIndex++) {
      var selection = {};
      var hasAllOtherSelections = true;

      for (var i = 0; i < optionCount; i++) {
        if (i === targetIndex) continue;
        var selectedValue = $form.find('input[name="option-' + i + '"]:checked').val();
        if (selectedValue === undefined) {
          hasAllOtherSelections = false;
          break;
        }
        selection[i] = selectedValue;
      }

      if (!hasAllOtherSelections) continue;

      var availabilityByValue = {};

      // seed every value this option can take as unavailable, so combos
      // that don't exist for the current selection get grayed out too
      _.each(_product.variants, function (variant) {
        var value = variant.options[targetIndex];
        if (!(value in availabilityByValue)) {
          availabilityByValue[value] = false;
        }
      });

      _.each(_product.variants, function (variant) {
        for (var i = 0; i < optionCount; i++) {
          if (i === targetIndex) continue;
          if (variant.options[i] != selection[i]) return;
        }
        var value = variant.options[targetIndex];
        availabilityByValue[value] = availabilityByValue[value] || variant.available;
      });

      $.each(availabilityByValue, function (value, available) {
        var $swatch = $form.find('.swatch[data-option-index="' + targetIndex + '"] .swatch-element[data-value="' + value + '"]');
        $swatch[available ? 'addClass' : 'removeClass']('available');
        $swatch[!available ? 'addClass' : 'removeClass']('soldout');
      });
    }
  }

  function initProduct() {
    var $mobileCarousel = getPrimaryMobileCarousel();

    preloadCarouselImages();

    // Init carousel
    bootMobileProductCarousel();

    // On lazy load complete, resize flickity
    $(document).on('mobile-carousel-images-loaded', function () {
      var flkty = getMobileCarouselInstance($mobileCarousel);

      if ($mobileCarousel.length && flkty) {
        flkty.resize();
        ensureMobileCarouselDots($mobileCarousel);
      }
    });

    $(window).off('load.mobileProductCarousel').on('load.mobileProductCarousel', function () {
      bootMobileProductCarousel();
    });

    $(window).off('resize.mobileProductCarousel').on('resize.mobileProductCarousel', function () {
      var flkty = getMobileCarouselInstance($mobileCarousel);

      if (flkty) {
        flkty.resize();
        return;
      }

      bootMobileProductCarousel();
    });

    //on product select callback AKT Aug 28
    $('body').on('selectCallbackAddon', function (event, variant, selector) {
      //mobile slider filtering
      if (variant && variant.featured_image != null) {
        if (variant.featured_image.alt != null) {

          if (variant.featured_image.alt.indexOf("swatch") > -1) {
            let feat_img_alt = variant.featured_image.alt;
            if ($mobileCarousel.length && getMobileCarouselInstance($mobileCarousel)) {
              destroyMobileCarousel($mobileCarousel);
            }
            $mobileCarousel.html("");
            let arrayLength = _product.media.length;
            for (var i = 0; i < arrayLength; i++) {
              let img_alt = _product.media[i].alt;
              if (img_alt == feat_img_alt) {
                $mobileCarousel.append("<div class='carousel-cell'><img src='" + _product.media[i].src + "' alt='" + img_alt + "'></div>");
              }
            }
            bootMobileProductCarousel();
          }
        }
      }
    });

    // swatch availability on page load
    updateSwatchAvailability(_product);

    $('.product-form-' + _product.id + ' .swatch-element').on('click', function () {
      var optionIndex = parseInt($(this).closest('.swatch').data('option-index'), 10);
      if (!isNaN(optionIndex)) {
        window.lastChangedOptionIndex = optionIndex;
      }
      setTimeout(function () {
        updateSwatchAvailability(_product);
      }, 100);
    });
  }
  function initRelatedItemCarousel() {
    var $swatch = $('.swatch-element-related');
    $swatch.on('click', function (e) {
      e.preventDefault();
      var $swatchContainer = $(e.currentTarget).closest('.swatch');
      $swatchContainer.find('input[type="radio"]').prop('checked', false);
      $(e.currentTarget).find('input[type="radio"]').prop('checked', true);
      // Update Variant Selected for ATC      
      var $form = $(e.currentTarget).closest('.product_form');
      var selectedColor = $form.find('.swatch[data-option-index="0"] input:checked').val();
      var selectedSize = $form.find('.swatch[data-option-index="1"] input:checked').val();
      var product_id = $form.data('product-id');

      var product = _.filter(_products, function (product) {
        return product.id == product_id;
      })[0].json;

      var variant = _.filter(product.variants, function (variant) {
        return variant.option1 == selectedColor && variant.option2 == selectedSize;
      })[0];
      if (variant !== undefined) {
        var $select = $form.find('select[name="id"]');
        $select.val(variant.id).trigger('change');

        var $quickForm = $('form#form--quick-atc-' + product.id);
        var $quickFormVariant = $quickForm.find('input[name="id"]');
        $quickFormVariant.val(variant.id);

        var $atc = $quickForm.find('.btn');
        $atc.prop('disabled', !variant.available).val(variant.available ? 'Add to cart' : 'Sold out');

        // Update link url
        var $link = $form.closest('.product-link');
        $link.attr('href', product.url + '?variant=' + variant.id);
      }
    });
  }


  $(function () {
    var hasProductSection = $('[data-section-type="product-section"]').length > 0
      || $('.product-page.product-template').length > 0
      || $('.mobile-images .mobile-carousel').length > 0;
    var isProductTemplate = window._template && window._template.name === 'product';

    if (hasProductSection || isProductTemplate) {
      initProduct();
      initRelatedItemCarousel();
    }

    /*
      Legacy collection/home hover carousel init is no longer used.
      Leaving it commented for easy rollback.
    var isCollectionPage = $('body').hasClass('collection');
    var isHomePage = $('body').hasClass('index');
    if (isCollectionPage || isHomePage) {
      initProductsHover();
    }
    */
  });
  $( document ).ready(function() {

    /* stones swatches*/

    if (window.matchMedia('(min-width: 768px)').matches) {
      $( ".options-sw-essentialwrapper .options-featuredgem" ).each(function( index ) {

        $( this ).appendTo('.options-sw-featuredwrapper .options-sw-grid-items');
      
      });
    }

    if ( $( ".options-sw-item-popup-featlabel" ).length ) {       
      $( ".options-sw-wrapper-popup .options-featuredgem" ).each(function( index ) {

        $( this ).insertAfter('.options-sw-wrapper-popup .options-sw-item-popup-featlabel:first-of-type');
      
      });
    }

    var container = $(".options-sw-wrapper-popupoverlay .options-sw-grid-items-popup"); // Replace '.container' with the actual container element class or ID

    // Get all <a> elements with the class "options-sw-item-popup"
    var items = container.find("a.options-sw-item-popup:not(.options-featuredgem)");

    // Sort the items alphabetically based on the text inside each .options-sw-item-label-popup div
    items.sort(function(a, b) {
      var textA = $(a).find(".options-sw-item-label-popup:not(.options-featuredgem)").text().trim().toLowerCase();
      var textB = $(b).find(".options-sw-item-label-popup:not(.options-featuredgem)").text().trim().toLowerCase();
      return textA.localeCompare(textB);
    });

    // Append the sorted items back to the container
    container.append(items);

    $( ".options-sw-wrapper-popupoverlay" ).prependTo('body');

    $(document).on('click', '.options-sw-mobselect', function(e) { 
      $( ".options-sw-wrapper-popupoverlay" ).fadeIn();
      $( ".options-sw-wrapper-popupoverlay" ).addClass('options-sw-wrapper-popupoverlayactive'); 
    });
  
    $(document).on('click', '.options-sw-mobselectclose', function(e) { 
      $( ".options-sw-wrapper-popupoverlay" ).fadeOut();
      $( ".options-sw-wrapper-popupoverlay" ).removeClass('options-sw-wrapper-popupoverlayactive'); 
    });

    $(".options-sw-grid-items").on('scroll', function () {
        if($(this).scrollLeft() > 0) {
          $(".options-sw-grid-items").addClass('divscrolled');    
        } else {
          $(".options-sw-grid-items").removeClass('divscrolled');  
        }
    });

    $(".options-sw-grid-items-popup").on('scroll', function () {
      if($(this).scrollTop() > 0) {
        $(".options-sw-grid-items-popup").addClass('divscrolled');    
      } else {
        $(".options-sw-grid-items-popup").removeClass('divscrolled');  
      }
    });

    /* zodiac signs swatches*/

    $( ".zoptions-sw-wrapper-popupoverlay" ).prependTo('body');

    $(document).on('click', '.zoptions-sw-mobselect', function(e) { 
      $( ".zoptions-sw-wrapper-popupoverlay" ).fadeIn();
      $( ".zoptions-sw-wrapper-popupoverlay" ).addClass('zoptions-sw-wrapper-popupoverlayactive'); 
    });
  
    $(document).on('click', '.zoptions-sw-mobselectclose', function(e) { 
      $( ".zoptions-sw-wrapper-popupoverlay" ).fadeOut();
      $( ".zoptions-sw-wrapper-popupoverlay" ).removeClass('zoptions-sw-wrapper-popupoverlayactive'); 
    });

    $(".zoptions-sw-grid-items").on('scroll', function () {
        if($(this).scrollLeft() > 0) {
          $(".zoptions-sw-grid-items").addClass('divscrolled');    
        } else {
          $(".zoptions-sw-grid-items").removeClass('divscrolled');  
        }
    });

    $(".zoptions-sw-grid-items-popup").on('scroll', function () {
      if($(this).scrollTop() > 0) {
        $(".zoptions-sw-grid-items-popup").addClass('divscrolled');    
      } else {
        $(".zoptions-sw-grid-items-popup").removeClass('divscrolled');  
      }
    });
  
  });
  
})(jQuery);
$(document).ready(function() {
  theme.sections = theme.sections || new theme.Sections();
  theme.sections.register('product-section', theme.Product);
});
